import * as React from "react";
import {
  Input as ChakraInput,
  InputGroup as ChakraInputGroup,
  type InputProps as ChakraInputProps,
  type InputGroupProps as ChakraInputGroupProps,
} from "@chakra-ui/react";

export interface InputProps extends Omit<ChakraInputProps, "variant"> {
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
  variant?: "outline" | "search" | "dialog";
  groupProps?: Omit<ChakraInputGroupProps, "children">;
}

export const Input: React.FC<InputProps> = ({
  startElement,
  endElement,
  groupProps,
  variant,
  ...inputProps
}) => {
  return (
    <ChakraInputGroup startElement={startElement} endElement={endElement} {...groupProps}>
      <ChakraInput variant={variant as ChakraInputProps["variant"]} {...inputProps} />
    </ChakraInputGroup>
  );
};
